export default [
  {
    path: 'pesquisa',
    name: 'surveys',
    component: () => import(/* webpackChunkName: "surveys" */ './Index.vue'),
    meta: {
      title: 'Pesquisas de satisfação',
      admin: true
    },
    children: [
      {
        path: 'pesquisa/:id',
        name: 'admin.surveys.view',
        component: () => import(/* webpackChunkName: "surveys" */ './View.vue'),
      }
    ]
  },
];
